module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("71vzG"))).then(() => parcelRequire('fThBo'));